/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

export const badgeTitlesAndLabelsMap = {
  // This object serves as the priority and mapping of entity boolean properties to their badge title and popover text
  isFeatured: ['Featured', 'Our recommended listings'],
  isAirbnbFriendly: [
    'Airbnb-friendly',
    'This property allows residents to earn extra money from hosting on Airbnb part-time. Hosting is subject to rules and restrictions. Ask property management for details.',
  ],
  hasResidentQuotes: [
    'Resident insights',
    'Read quotes from current residents or connect with them directly to hear what it’s like to live at this community.',
  ],
  isHighestRated: ['Highly rated', 'Highest-rated on the web'],
  isIncomeRestricted: ['Income restricted', 'This listing has specific income requirements'],
  isAgeRestricted: ['Age restricted', 'There is an age requirement to rent this listing'],
  isStudentHousing: ['Student housing', 'This listing has per bed occupancy'],
  isMilitaryHousingFeature: [
    'Military housing',
    'This listing is intended for active & inactive military personnel',
  ],
  isRentSpecial: ['Rent special', 'Special offer available'],
  isNoDeposit: ['No deposit', 'A security deposit is not required for qualified renters'],
  isExclusive: ['Exclusive', 'This listing is only available on Zumper'],
  isNewConstruction: ['New construction', 'This property was built less than 2 years ago'],
  hasIframeMedia: ['3D tour', 'This listing offers 3D tours'],
} as const

export const badgePropertyArray = Object.keys(
  badgeTitlesAndLabelsMap
) as (keyof typeof badgeTitlesAndLabelsMap)[]
